module.exports = __webpack_public_path__ + "ag.dd00102de657700f816b.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ag.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ag.svg
// module chunks = styles